// extracted by css-extract-rspack-plugin
var _1 = "G5Lj8";
export { _1 as "content" }
